import {Method, NetworkType} from '@/libs/wallet-connect-sdk-core/types'

export class N3WalletConnectConfig {
  static readonly methods: Method[] = ['invokeFunction']

  static readonly network: NetworkType = 'neo3:mainnet'
}
